<div class="tipps">
  @for (tipp of tipps | slice:0:tippCount; track tipp; let i = $index) {
    <div>
      <div class="tipp-item">
        <div class="grid-x grid-padding-x">
          <div class="cell cell-flex small-10 medium-4">
            <div><strong class="name">{{tipp.position | translate}}</strong></div>
          </div>
          <div class="cell cell-flex small-10 medium-6">
            <div class="cost-wrapper">
              <div>{{'bekochek.ergebnis.own.value' | translate: {value: tipp.userAverage | number: '1.2-2'} }}</div>
              <div class="cost-bar stage{{tipp.stage}}" [style.width]="tipp.widthUser"></div>
              <div class="cost-bar" [style.width]="tipp.widthAvg"></div>
              <div>{{'bekochek.ergebnis.average.value' | translate: {value: tipp.average | number: '1.2-2'} }}</div>
            </div>
          </div>
          <div class="cell cell-flex small-2">
            <button type="button" tabindex="0" [attr.aria-expanded]="tipp.showInfo" [attr.aria-controls]="'info-' + i" class="chevron" (click)="tipp.showInfo = !tipp.showInfo">
              <i class="icon-chevron-down" [class.show]="tipp.showInfo"></i>
            </button>
          </div>
          @if (tipp.showInfo) {
            <div [id]="'info-' + i" class="tipp-info">
              <div class="grid-x grid-padding-x">
                <div class="cell small-12 medium-{{ tipp.image ? 12 : 8 }} text-right">
                  <button type="button" class="close" [attr.aria-label]="'arialabel.close' | translate" (click)="tipp.showInfo=false"><i class="icon-x"></i></button>
                </div>
                @if (tipp.image) {
                  <div class="cell small-12 medium-4 text-center">
                    <img [src]="tipp.image" alt="">
                  </div>
                }
                <div class="cell small-12 medium-8">
                  @if (tipp.texts.text) {
                    <span [innerHTML]="tipp.texts.text | translate"></span>
                  }
                  @if (tipp.texts.headline) {
                    <h3 [innerHTML]="tipp.texts.headline | translate"></h3>
                  }
                  @if (tipp.texts.teaser) {
                    <span [innerHTML]="tipp.texts.teaser | translate"></span>
                  }
                  @if (tipp.texts.link && tipp.texts.buttontext) {
                    <a class="button signal2 inline-arrow-right" [href]="tipp.texts.link | translate" target="_blank"
                      [innerHTML]="tipp.texts.buttontext | translate">
                    </a>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  }
  @if (tipps.length > tippCountDefault) {
    <div class="more">
      <div class="grid-x grid-padding-x">
        <div class="cell text-right">
          @if (tipps.length > tippCount) {
            <button class="button primary inline-arrow-right button-tipp" (click)="tippCount = tipps.length">
              <span [innerHTML]="textkeyBase + 'all' | translate: {count: tipps.length}"></span>
            </button>
          }
          @if (tipps.length === tippCount) {
            <button class="button primary inline-arrow-right button-tipp" (click)="tippCount = tippCountDefault">
              <span [innerHTML]="textkeyBase + 'less' | translate"></span>
            </button>
          }
        </div>
      </div>
    </div>
  }

  <div class="smoke-detector">
    <app-advisor-image [path]="'/bkc/smoke-detector.svg'"></app-advisor-image>
    <p [innerHtml]="textkeyBase + 'smoke_detector' | translate"></p>
  </div>
</div>
